import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledTab = styled.div`
  & .tabs-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    top: 15px;
    margin-top: -15px;
  }

  & .left-tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  & .right-tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    & .right-content {
      margin-bottom: 23px;
      margin-right: 2px;
    }
  }
`;

export const StyledTabItem = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px 25px 15px;
  border-radius: ${theme.variables.border_radius_2}
    ${theme.variables.border_radius_2} 0 0;
  background-color: ${({ $active }) => $active && theme.colors.white};

  & svg {
    stroke: ${({ $active }) => $active && theme.colors.purple};
  }

  &:hover svg path {
    stroke: ${({ $active }) => $active && theme.colors.purple};
  }

  & span {
    color: ${({ $active }) => $active && theme.colors.purple};
  }
`;
